// JS que manda y checa informacion a localstorage y desactiva componentes a css, Ej. Header barra de anuncios y cronometro

$(document).ready(function(){
    // variables
    const d = new Date()

    // acciones
    $('.js-close-local__content').each( function() {
        if ( $(this).data('close-local__time') != null ) {
            setTimeout(() => {
                closeConfirmar($(this))
            }, $(this).data('close-local__time') )
        }else{
            closeConfirmar($(this))
        }
    })

    $('body').on('click', '.js-close-local__action', function(event) {
        closeAgrearLocal($(this))
    })

    // funciones
    function closeConfirmar(item) {
        const date = d.getDate()
        let data = false
        
        for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i) == item.data('close-local__local')) {
                if (localStorage.getItem(item.data('close-local__local')) != date ) {
                    localStorage.removeItem(item.data('close-local__local'))
                }
            }

            if (localStorage.key(i) == item.data('close-local__local')) {
                data = true
            }
        }

        if (data) {
            item.removeClass(item.data('close-local__active'))
        }else{
            item.addClass(item.data('close-local__active'))
        }
    }

    function closeAgrearLocal(action) {
        const date = d.getDate()
        localStorage.setItem(action.data('close-local__local'), date)
    }
})
